import './fonts.css';

export const FontFamily = 'INGMeWeb';
export const FontFamilyDisplay = 'INGDisplay';

const customFonts = {
  IngMeWebRegular: `${FontFamily}, Helvetica, Arial, sans-serif`,
  IngMeWebRegularItalic: `${FontFamily}, Helvetica, Arial, sans-serif`,
  IngMeWebBold: `${FontFamily}, Helvetica, Arial, sans-serif`,
  IngMeWebBoldItalic: `${FontFamily}, Helvetica, Arial, sans-serif`,
  IngDisplayBold: `${FontFamilyDisplay}, Helvetica, Arial, sans-serif`,
}

export const FontWeight = {
    REGULAR: 400,
    BOLD: 700,
  } as const;


export default customFonts;
